<template>
  <div class="row wolt-integration-form marketplace-settings">
    <div class="col-md-12">
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-location-pin" aria-hidden="true"></i><div><h6>{{ $t('marketplace.locations') }}</h6><p>{{ $t('marketplace.locationsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('location_id') }">
        <label for="wolt-location_id">{{ $t('marketplace.menuLocation') }}<span v-if="isRequired('location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.location_id"
          id="wolt-location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'wolt-loc-' + String(loc._integrationLocationId)"
            :value="loc._integrationLocationId"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.menuHint') }}</p>
        <span v-if="showFieldError('location_id')" class="text-danger help-block">{{ fieldErrorMessage('location_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('orders_location_id') }">
        <label for="wolt-orders_location_id">{{ $t('marketplace.ordersLocation') }}<span v-if="isRequired('orders_location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.orders_location_id"
          id="wolt-orders_location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'wolt-orders-loc-' + String(loc._integrationLocationId)"
            :value="locationOptionValue(loc)"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.ordersHint') }}</p>
        <span v-if="showFieldError('orders_location_id')" class="text-danger help-block">{{ fieldErrorMessage('orders_location_id') }}</span>
      </div>
    </div>

        </div>
      </section>
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-key" aria-hidden="true"></i><div><h6>{{ $t('marketplace.credentials') }}</h6><p>{{ $t('marketplace.credentialsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('api_url') }">
        <label>{{ fieldLabel('api_url') }}<span v-if="isRequired('api_url')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.api_url"
          :disabled="disabled"
        >
        <span v-if="showFieldError('api_url')" class="text-danger help-block">{{ fieldErrorMessage('api_url') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('api_key') }">
        <label>{{ fieldLabel('api_key') }}<span v-if="isRequired('api_key')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.api_key"
          :disabled="disabled"
        >
        <span v-if="showFieldError('api_key')" class="text-danger help-block">{{ fieldErrorMessage('api_key') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('client_id') }">
        <label>{{ fieldLabel('client_id') }}<span v-if="isRequired('client_id')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.client_id"
          :disabled="disabled"
        >
        <span v-if="showFieldError('client_id')" class="text-danger help-block">{{ fieldErrorMessage('client_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('client_secret') }">
        <label>{{ fieldLabel('client_secret') }}<span v-if="isRequired('client_secret')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.client_secret"
          :disabled="disabled"
        >
        <span v-if="showFieldError('client_secret')" class="text-danger help-block">{{ fieldErrorMessage('client_secret') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('venue_id') }">
        <label>{{ fieldLabel('venue_id') }}<span v-if="isRequired('venue_id')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.venue_id"
          :disabled="disabled"
        >
        <span v-if="showFieldError('venue_id')" class="text-danger help-block">{{ fieldErrorMessage('venue_id') }}</span>
      </div>
    </div>


        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { integrationLocationOptionValue } from 'src/components/Dashboard/Views/Integrations/integrationLocationHelpers.js'
import {
  getIntegrationFieldErrorMessage,
  hasIntegrationFieldError
} from 'src/components/Dashboard/Views/Integrations/integrationFormFieldHelpers.js'

export const DEFAULT_WOLT_API_URL = 'https://pos-integration-service.wolt.com'
export const DEFAULT_WOLT_API_KEY = '8XQROyovhJN3-zbg4xjfvKshrvSfbAglVi6jODoSbvE='
export const DEFAULT_WOLT_CLIENT_ID = 'b1eff6b5-1bf7-4ba2-b899-1e8c3b9c356e'
export const DEFAULT_WOLT_CLIENT_SECRET = 'IAsSkcQ0djcT9RqfemhhZTsTfQ'

export function defaultWoltSchedule () {
  const day = {
    open: true,
    intervals: [{ opening_time: '10:00', closing_time: '22:00' }]
  }
  return Array.from({ length: 7 }, () => JSON.parse(JSON.stringify(day)))
}

export default {
  name: 'WoltIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.ensureSchedule()
    this.ensureBooleanDefaults()
    this.ensureDefaults()
  },
  methods: {
    fieldLabel (field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field)
      return field
    },
    isRequired (field) {
      return (this.requiredFields || []).includes(field)
    },
    hasFieldError (field) {
      return Boolean(this.validationErrors && this.validationErrors[field])
    },
    showFieldError (field) {
      return hasIntegrationFieldError({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      })
    },
    fieldErrorMessage (field) {
      return getIntegrationFieldErrorMessage({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      })
    },
    locationOptionValue (loc) {
      return integrationLocationOptionValue(loc)
    },
    ensureSchedule () {
      if (!Array.isArray(this.formData.schedule) || !this.formData.schedule.length) {
        this.$set(this.formData, 'schedule', defaultWoltSchedule())
      }
    },
    ensureBooleanDefaults () {
      const boolFields = ['active', 'is_auto_accept']
      boolFields.forEach(f => {
        if (this.formData[f] === undefined || this.formData[f] === null || this.formData[f] === '') {
          this.$set(this.formData, f, false)
        } else {
          this.$set(this.formData, f, Boolean(this.formData[f]))
        }
      })
    },
    ensureDefaults () {
      const defaults = {
        api_url: DEFAULT_WOLT_API_URL,
        api_key: DEFAULT_WOLT_API_KEY,
        client_id: DEFAULT_WOLT_CLIENT_ID,
        client_secret: DEFAULT_WOLT_CLIENT_SECRET
      }
      Object.entries(defaults).forEach(([key, value]) => {
        const current = this.formData[key]
        if (current === undefined || current === null || String(current).trim() === '') {
          this.$set(this.formData, key, value)
        }
      })
    }
  }
}
</script>

<style scoped>
.wolt-integration-form .has-error .form-control { border-color: #dc3545; }
.wolt-integration-form .help-block { margin-top: 4px; margin-bottom: 0; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/WoltIntegrationForm.vue